import { createRouter, createWebHashHistory, RouteRecordRaw } from 'vue-router';
import Entry from '@/views/Entry.vue';
// import { findMenuModelNames } from '@/composition/useStoreFunc';
import { logout } from '../utils/index';
import { registerRoutes } from './base.js';
import microDataReport from '@/views/microDataReport/index.vue';
import microOtp from '@/views/microOtp/index.vue';
import microOms from '@/views/microOms/index.vue';
import microTms from '@/views/microTms/index.vue';
import microNtp from '@/views/microNtp/index.vue';
import microLsp from '@/views/microLsp/index.vue';
import microLsrm from '@/views/microLsrm/index.vue';
import microAms from '@/views/microAms/index.vue';
import microPrivacy from '@/views/microPrivacy/index.vue';
import microReport from '@/views/microReport/index.vue';
import cciMicroApp from '@/views/cciMicroApp/index.vue';
import lspBmsMicroApp from '@/views/lspBmsMicroApp/index.vue';
import lspCopMicroApp from '@/views/lspCopMicroApp/index.vue';
import lspAmsMicroApp from '@/views/lspAmsMicroApp/index.vue';
import microCsp from '@/views/microCsp/index.vue';
import microEam from '@/views/microEam/index.vue';
import Login from '@/views/login/index.vue';
import store from '@/store/index';
declare const window: any;
// const bigDataConfig: any = bigLogData;
const routes: Array<RouteRecordRaw> = [
  {
    path: '/',
    redirect: '/index',
  },
  {
    path: '/microOtp/:page*',
    name: 'microOtp',
    component: microOtp, // 用于解决"microOtp前缀开头"路径兼容处理, 首次打开/microOtp前缀的路径去加载microOms子应用，由子应用根据发起子系统匹配替换
  },
  {
    path: '/',
    redirect: '/index',
    name: 'entry',
    component: Entry,
    children: [
      {
        path: '/redirect/:path*',
        component: () => import('@/views/Redirect.vue'),
      },
      {
        path: '/401',
        name: '401',
        component: () => import('@/views/401.vue'),
      },
      {
        path: '/microDataReport/:page*',
        name: 'microDataReport',
        component: microDataReport,
      },
      {
        path: '/microOms/:page*',
        name: 'microOms',
        component: microOms,
      },
      {
        path: '/microTms/:page*',
        name: 'microTms',
        component: microTms,
      },
      {
        path: '/microNtp/:page*',
        name: 'microNtp',
        component: microNtp,
      },
      {
        path: '/microLsp/:page*',
        name: 'microLsp',
        component: microLsp,
      },
      // {
      //   path: '/report/:page*',
      //   name: 'report',
      //   component: lspMicroAppReportApp,
      // },
      {
        path: '/microLsrm/:page*',
        name: 'microLsrm',
        component: microLsrm,
      },
      {
        path: '/microAms/:page*',
        name: 'microAms',
        component: microAms,
      },
      {
        path: '/microLsp/app-cci/:page*',
        name: 'app-cci',
        component: cciMicroApp,
      },
      {
        path: '/microLsp/bmsMicroApp/:page*',
        name: 'bmsMicroApp',
        component: lspBmsMicroApp,
      },
      {
        path: '/microLsp/app-cop/:page*',
        name: 'app-cop',
        component: lspCopMicroApp,
      },
      {
        path: '/microLsp/outPage/:page*',
        name: 'ams',
        component: lspAmsMicroApp,
      },
      {
        path: '/microReport/:page*',
        name: 'report',
        component: microReport,
      },
      {
        path: '/microPrivacy/:page*',
        name: 'privacy',
        component: microPrivacy,
      },
      {
        path: '/microCsp/:page*',
        name: 'csp',
        component: microCsp,
      },
      {
        path: '/microEam/:page*',
        name: 'eam',
        component: microEam,
      },
      {
        path: '/index',
        name: '工作台',
        component: () => import('@/views/Home.vue'),
      },
      {
        path: '/:catchAll(.*)',
        name: '404',
        component: () => import('@/views/404.vue'),
      },
    ],
  },
  // h5 页面 免登录
  {
    path: '/h5/bulletin-board',
    name: 'bulletinBoard',
    component: () => import('@/views/h5App/bulletinBoard/index.vue'),
  },

  // h5 页面 24小时逾期 免登录
  {
    path: '/h5/overdueUnfulfilled24h',
    name: 'overdueUnfulfilled24h',
    component: () => import('@/views/h5App/overdueUnfulfilled24h/index.vue'),
  },
  {
    path: '/login',
    name: 'login',
    component: Login,
  },
];

const router = createRouter({
  history: createWebHashHistory(),
  routes,
});

// 记录是否已生成动态路由
let regeisteredRoute = false;

router.beforeEach((to, from, next) => {
  if (sessionStorage.getItem('is_logout')) {
    return logout();
  }
  if (!regeisteredRoute && to.name !== 'login') {
    registerRoutes(() => {
      next({ path: to.fullPath });
      // replace 避免动态路由注册后同路径二次导航导致埋点重复（参照 OTP 单次 beforeEach 上报）
      // next({ ...to, replace: true });
      // // 解决通过连接进来没有记录对应页面埋点问题
      // setTimeout(() => {
      //   const modelNames = findMenuModelNames(to.path)?.map((i) => i.resourceName);
      //   if (modelNames && modelNames.length) {
      //     const bigParams: any = {};
      //     modelNames.forEach((name: string, index: number) => {
      //       bigParams['model_name' + (index + 1)] = name;
      //     });
      //     bigDataLog.sendDetailMessage(bigParams);
      //   }
      // }, 0);
    });
    regeisteredRoute = true;
    // 系统初始化成功后，记录用户访问次数
    // bigDataLog.sendMainMessage();
    return;
  }
  // bigDataLog.route = to; // 记录当前路由
  // 各页面添加各自大数据埋点变量
  // window.bigDataConfig = to.name ? bigDataConfig[to.name] : {};
  // router catchAll之后路由对象会被存放到redirectedFrom
  if (to.redirectedFrom && to.redirectedFrom.path === to.path) {
    to.fullPath = to.redirectedFrom.fullPath;
    to.params = to.redirectedFrom.params;
    to.query = to.redirectedFrom.query;
    to.meta = to.redirectedFrom.meta;
  }
  next();
});

// 物流微前端通用解决方案
let timer: any = null;
const customerAnntoRouter = (target, prop, to) => {
  // 判断处于微前端环境
  let mainPath = '';
  if (typeof to === 'string') {
    mainPath = to;
  } else if (typeof to === 'object' && to.name) {
    const matchedRoute = target.resolve(to);
    if (matchedRoute) {
      // vue-router 4X : matchedRoute.path, vue-router3X :  matchedRoute.route.path
      mainPath = matchedRoute.path || matchedRoute.route.path;
    }
  } else if (typeof to === 'object' && to.path) {
    mainPath = to.path;
  }
  // target[prop](to);

  const baseRouter = window.microApp.getData().router; // 获取主应用路由
  // eslint-disable-next-line no-unused-expressions
  cancelTimer();
  timer = setTimeout(() => {
    baseRouter &&
      baseRouter.push({
        path: mainPath,
        query: to.query,
      });
  }, 0);
};
const cancelTimer = () => {
  clearTimeout(timer);
  timer = null;
};
// 代理router，拦截push和replace方法，如果是微前端环境则触发主应用跳转
const routerProxy = new Proxy(router, {
  get(target, prop, receiver) {
    if (prop === 'push' || prop === 'replace') {
      return cunstomPushAndReplace(target, prop);
    }
    return Reflect.get(target, prop, receiver);
  },
});
// 子系统映射
const systemMapping = { 
  'tms': 'microTms',
  'oms': 'microOms',
  'el-data-report': 'microDataReport',
  'lsp': 'microLsp',
  'lsrm': 'microLsrm',
  'ntp': 'microNtp'
};
const cunstomPushAndReplace = (target, prop) => {
  return (to) => {
    if (to && to.params) {
      const changedParams = Object.keys(to.params).reduce((pre, cur) => {
        pre['_p_' + cur] = to.params[cur];
        return pre;
      }, {});
      to.query = { ...to.query, ...changedParams };
    }
    if (window.__MICRO_APP_ENVIRONMENT__) {
      customerAnntoRouter(target, prop, to);
    } else {
      return target[prop](to);
    }
  };
};
export default routerProxy;
